import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import {
  getRecipeById,
  updateRecipe,
  getRecipeDetails,
  addRecipeDetails,
  updateRecipeDetails,
  getIngredients,
  updateIngredients,
} from "../../api/api";

class RecipeDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recipeId: null,

      recipe_title: "",
      recipe_description: "",

      detailsId: null,
      cooking_process: "",
      tips_facts: "",

      rawIngredientsText: "",
      previewIngredients: [],

      isEditingDetails: false,
      recipe_image: null,
      newImage: null,
      isEditingRecipe: false,
      hero_recipe: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.router.params;

    this.setState({ recipeId: id }, () => {
      this.loadRecipe();
      this.loadDetails();
    });
  }

  // ================= LOAD RECIPE =================
  loadRecipe = async () => {
    try {
      const res = await getRecipeById(this.state.recipeId);

      if (res.data.length > 0) {
        this.setState({
          recipe_title: res.data[0].recipe_title,
          recipe_description: res.data[0].recipe_description,
          recipe_image: res.data[0].recipe_image,
          hero_recipe: res.data[0].hero_recipe === 1,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleUpdateRecipe = async () => {
    const {
      recipeId,
      recipe_title,
      recipe_description,
      newImage,
      hero_recipe,
    } = this.state;

    try {
      const formData = new FormData();
      formData.append("catgeory_id", 1);
      formData.append("recipe_title", recipe_title);
      formData.append("description", recipe_description);
      formData.append("hero_recipe", hero_recipe ? 1 : 0);

      if (newImage) {
        formData.append("image", newImage);
      }

      await updateRecipe(recipeId, formData);

      alert("Recipe Updated Successfully");

      this.setState({
        isEditingRecipe: false,
        newImage: null,
      });

      this.loadRecipe();
    } catch (error) {
      console.error(error);
    }
  };

  // ================= LOAD DETAILS =================
  loadDetails = async () => {
    try {
      const res = await getRecipeDetails(this.state.recipeId);

      if (res.data.length > 0) {
        const details = res.data[0];
        const detailsId = details.recipe_details_id || details.id;

        this.setState(
          {
            detailsId,
            cooking_process: details.cooking_process,
            tips_facts: details.tips_facts,
            isEditingDetails: false,
          },
          () => this.loadIngredients(detailsId)
        );
      } else {
        this.setState({ isEditingDetails: true });
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ================= LOAD INGREDIENTS =================
  loadIngredients = async (detailsId) => {
    try {
      const res = await getIngredients(detailsId);

      if (res.data.length > 0) {
        const text = res.data
          .map(
            (item) =>
              `${item.ingredient_name}${
                item.preparation ? `: ${item.preparation}` : ""
              }`
          )
          .join("\n");

        this.setState({
          rawIngredientsText: text,
          previewIngredients: res.data,
        });
      } else {
        this.setState({
          rawIngredientsText: "",
          previewIngredients: [],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ================= PARSER =================
  parseIngredients = (text) => {
    return text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line !== "")
      .map((line) => {
        const parts = line.split(":");

        const name = parts.shift();
        const preparation = parts.join(":");

        return {
          ingredient_name: name ? name.trim() : "",
          preparation: preparation ? preparation.trim() : "",
        };
      });
  };

  // ================= SAVE INGREDIENTS =================
  handleSaveParsedIngredients = async () => {
    const { detailsId, rawIngredientsText } = this.state;

    if (!detailsId) {
      alert("Save details first");
      return;
    }

    const parsed = this.parseIngredients(rawIngredientsText);

    if (parsed.length === 0) {
      alert("Nothing to save");
      return;
    }

    try {
      await updateIngredients({
        recipe_details_id: detailsId,
        ingredients: parsed,
      });

      alert("Ingredients Saved Successfully");

      this.loadIngredients(detailsId);
    } catch (error) {
      console.error(error);
    }
  };

  // ================= SAVE DETAILS =================
  handleSaveDetails = async () => {
    const { detailsId, recipeId, cooking_process, tips_facts } = this.state;

    try {
      if (detailsId) {
        await updateRecipeDetails(detailsId, {
          cooking_process,
          tips_facts,
        });
      } else {
        const res = await addRecipeDetails({
          recipe_id: recipeId,
          cooking_process,
          tips_facts,
        });

        this.setState({ detailsId: res.data.id });
      }

      alert("Details Saved Successfully");
      this.setState({ isEditingDetails: false });
      this.loadDetails();
    } catch (error) {
      console.error(error);
    }
  };

  // ================= RENDER =================
  render() {
    const {
      recipe_title,
      recipe_description,
      cooking_process,
      tips_facts,
      rawIngredientsText,
      previewIngredients
    } = this.state;

    return (
      <div className="container mt-4">

        {/* ===== RECIPE HEADER ===== */}
        <div className="card shadow mb-4">
          <div className="card-body">
            <h3>{recipe_title}</h3>
            <p>{recipe_description}</p>
          </div>
        </div>

        {/* ===== DETAILS ===== */}
        <div className="card shadow mb-4">
          <div className="card-body">
            <textarea
              className="form-control mb-2"
              rows="5"
              placeholder="Cooking Process"
              value={cooking_process}
              onChange={(e) =>
                this.setState({ cooking_process: e.target.value })
              }
            />

            <textarea
              className="form-control mb-2"
              rows="3"
              placeholder="Tips & Facts"
              value={tips_facts}
              onChange={(e) =>
                this.setState({ tips_facts: e.target.value })
              }
            />

            <button
              className="btn btn-success"
              onClick={this.handleSaveDetails}
            >
              Save Details
            </button>
          </div>
        </div>

        {/* ===== INGREDIENTS ===== */}
        <div className="card shadow">
          <div className="card-body">
            <h5>Ingredients</h5>

            <textarea
              className="form-control"
              rows="6"
              placeholder={`Onion: finely chopped
Tomato: diced
Salt: to taste`}
              value={rawIngredientsText}
              onChange={(e) => {
                const text = e.target.value;

                this.setState({
                  rawIngredientsText: text,
                  previewIngredients: this.parseIngredients(text),
                });
              }}
            />

            <button
              className="btn btn-success mt-2"
              onClick={this.handleSaveParsedIngredients}
            >
              Save Ingredients
            </button>

            {/* PREVIEW */}
            {previewIngredients.length > 0 && (
              <div className="mt-3">
                <h6>Preview</h6>

                {previewIngredients.map((item, index) => (
                  <div key={index} className="row mb-2">
                    <div className="col-md-4">
                      <strong>{item.ingredient_name}</strong>
                    </div>
                    <div className="col-md-8">
                      {item.preparation}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      </div>
    );
  }
}

export default withRouter(RecipeDetails);